import React, { useContext } from 'react'
import RSRLLine from './RSRLLine'
import { useStaticQuery, graphql } from 'gatsby'

import { AccordionContext } from '../AccordionPage'

export default props => {
  const data = useStaticQuery(query)
  const edges = data.allRsrlIndicateursXlsxAbsenteisme.edges
  const page = props.page
  const slug = useContext(AccordionContext)

  let labels = edges.map((row, i) => row.node.ANNEE)
  let values = edges.map((row, i) => row.node.MOYENNE)

  return (
    <div className="text-content accordion-content accordion-table">
      <div
        className="beforeCanvas"
        dangerouslySetInnerHTML={{ __html: page.acf.headlines }}
      />
      <RSRLLine
        key={slug}
        label="Taux d'absentéisme"
        labels={labels}
        values={values}
        ylabel={'Taux'}
      />
      <div
        className="afterCanvas"
        dangerouslySetInnerHTML={{ __html: page.content }}
      />
    </div>
  )
}

const query = graphql`
  query {
    allRsrlIndicateursXlsxAbsenteisme {
      edges {
        node {
          ANNEE
          MOYENNE
        }
      }
    }
  }
`
